import React, { useState } from 'react'
import {
  withStyles,
  MenuItem,
  FormControl,
  Select,
  Divider,
  Typography,
  InputLabel,
  FormControlLabel,
} from '@material-ui/core'
import styles from './styles'
import InputAdornment from '@material-ui/core/InputAdornment'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { useSelector } from 'react-redux'
import { Icon } from '@iconify/react'
import { track } from '@amplitude/analytics-browser'

import translator from 'src/translate'
import CustomizedSwitch from 'src/components/customized-switch'
import { CoreButton, CoreTextField } from 'src/components/core'

const DEFAULT_SHARE_DOMAIN = process.env.REACT_APP_VIEW_URL?.replace(/^https?:\/\//, '').replace(/\/$/, '') || 'share.minicoursegenerator.com'

const ShareView = props => {
  const { entity, handleView, classes } = props

  const [copiedShareCode, setCopiedShareCode] = useState(false)
  const [showShareButtons, setShowShareButtons] = useState(0)

  const onClickShareCode = () => {
    track('collection_share_link_copied')

    setCopiedShareCode(true)
    setTimeout(() => {
      setCopiedShareCode(false)
    }, 1000)
  }

  const openNewWindow = () => {
    track('collection_preview_clicked')
    window.open(
      'https://' +
      domainName +
      '/category/' +
      collectionName
        .replaceAll(' ', '-')
        .replaceAll('?', '')
        .replaceAll('&', '')
        .replaceAll('#', '')
        .replaceAll('%', '') +
      '-1/' +
      entity.id +
      shareCode,
    )
  }
  const customDomain = useSelector(state => state.domain.list)

  const customDomainList = customDomain && customDomain.results
  const collectionDomain =
    customDomainList &&
    customDomainList.filter(
      item =>
        item.defaultCollectionDto != null &&
        item.defaultCollectionDto.id == entity.id &&
        item.verificationStatus == 1,
    )
  const [domains, setDomains] = useState(collectionDomain)
  const domain =
    collectionDomain.length > 0
      ? collectionDomain[0].domain
      : DEFAULT_SHARE_DOMAIN

  const [domainName, setDomainName] = useState(domain)
  const collectionName = entity.collectionName
    .replaceAll(/\?.*$/g, '')
    .replaceAll(' ', '-')
    .replaceAll('#', '')
    .replaceAll('%', '')

  const handleDomain = e => {
    setDomainName(e.target.value)
  }
  let shareCode = showShareButtons ? '?shr=1' : ''
  return (
    <div className={classes.shareViewRoot}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <Typography fontSize={'14px'} fontWeight={400} fontFamily={'Inter'}>
          Choose your domain
        </Typography>
        <FormControl
          variant="outlined"
          className={classes.shareViewFormControl}
        >
          <Select
            labelId="domain-selection-label"
            id="domain-selection-select"
            fullWidth
            value={domainName}
            disabled={false}
            onChange={handleDomain}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    marginLeft: '8px',
                    marginRight: '8px',
                    borderRadius: '8px',
                    marginTop: '4px',
                    marginBottom: '4px',
                  },
                },
              },
            }}
          >
            <MenuItem value={DEFAULT_SHARE_DOMAIN}>
              (Default) {DEFAULT_SHARE_DOMAIN}
            </MenuItem>

            {domains &&
              domains
                .filter(x => x.verificationStatus == 1)
                .map(value => {
                  return (
                    <MenuItem value={value.domain} key={value.domain}>
                      {value.domain}
                    </MenuItem>
                  )
                })}
          </Select>
        </FormControl>
        <Typography fontSize="12px" fontWeight={400} color="#015FFB">
          Want to customize the domain of the links?
        </Typography>
      </div>

      <CoreTextField
        fullWidth
        value={
          'https://' +
          domainName +
          '/category/' +
          collectionName
            .replaceAll(' ', '-')
            .replaceAll('?', '')
            .replaceAll('&', '')
            .replaceAll('#', '')
            .replaceAll('%', '') +
          '-1/' +
          entity.id +
          shareCode
        }
        label="Learning path link"
      />

      <CopyToClipboard
        text={
          'https://' +
          domainName +
          '/category/' +
          collectionName
            .replaceAll(' ', '-')
            .replaceAll('?', '')
            .replaceAll('&', '')
            .replaceAll('#', '')
            .replaceAll('%', '') +
          '-1/' +
          entity.id +
          shareCode
        }
      >
        <CoreButton
          onClick={onClickShareCode}
          variant="contained"
          color="primary"
          fullWidth
        >
          {copiedShareCode ? 'Copied!' : 'Copy Link'}
        </CoreButton>
      </CopyToClipboard>

      <Divider className={classes.shareViewDivider} />

      <div
        className={classes.shareViewOptions}
        onClick={() => handleView('embed-collection')}
      >
        <div className={classes.shareViewEmbedOption}>
          <Icon icon="iconoir:code" color="#FB9D01" fontSize={24} />
          <Typography
            style={{
              marginBottom: '4px',
            }}
          >
            Embed on a Website
          </Typography>
        </div>
        <Icon icon="ic:round-chevron-right" color="#002E47" fontSize={24} />
      </div>
    </div>
  )
}

export default withStyles(styles)(ShareView)
